'use strict';

var _AutoNumeric = require('./AutoNumeric');

var _AutoNumeric2 = _interopRequireDefault(_AutoNumeric);

var _AutoNumericHelper = require('./AutoNumericHelper');

var _AutoNumericHelper2 = _interopRequireDefault(_AutoNumericHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Pre-defined options for autoNumeric.js
 * @author Alexandre Bonneau <alexandre.bonneau@linuxfr.eu>
 * @copyright © 2016 Alexandre Bonneau
 *
 * The MIT License (http://www.opensource.org/licenses/mit-license.php)
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sub license, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 */

var euro = { // Français
    digitGroupSeparator: _AutoNumeric2.default.options.digitGroupSeparator.dot, // or '\u202f'
    decimalCharacter: _AutoNumeric2.default.options.decimalCharacter.comma,
    decimalCharacterAlternative: _AutoNumeric2.default.options.decimalCharacterAlternative.dot,
    currencySymbol: '\u202F\u20AC',
    currencySymbolPlacement: _AutoNumeric2.default.options.currencySymbolPlacement.suffix,
    negativePositiveSignPlacement: _AutoNumeric2.default.options.negativePositiveSignPlacement.prefix
};

var dollar = {
    digitGroupSeparator: _AutoNumeric2.default.options.digitGroupSeparator.comma,
    decimalCharacter: _AutoNumeric2.default.options.decimalCharacter.dot,
    currencySymbol: _AutoNumeric2.default.options.currencySymbol.dollar,
    currencySymbolPlacement: _AutoNumeric2.default.options.currencySymbolPlacement.prefix,
    negativePositiveSignPlacement: _AutoNumeric2.default.options.negativePositiveSignPlacement.right
};

var japanese = { // 日本語
    digitGroupSeparator: _AutoNumeric2.default.options.digitGroupSeparator.comma,
    decimalCharacter: _AutoNumeric2.default.options.decimalCharacter.dot,
    currencySymbol: _AutoNumeric2.default.options.currencySymbol.yen,
    currencySymbolPlacement: _AutoNumeric2.default.options.currencySymbolPlacement.prefix,
    negativePositiveSignPlacement: _AutoNumeric2.default.options.negativePositiveSignPlacement.right
};

// Here we need to clone the initial objects in order to be able to edit the clones without affecting the originals
var euroF = _AutoNumericHelper2.default.cloneObject(euro);
euroF.formulaMode = _AutoNumeric2.default.options.formulaMode.enabled;
var euroPos = _AutoNumericHelper2.default.cloneObject(euro);
euroPos.minimumValue = 0;
var euroNeg = _AutoNumericHelper2.default.cloneObject(euro);
euroNeg.maximumValue = 0;
euroNeg.negativePositiveSignPlacement = _AutoNumeric2.default.options.negativePositiveSignPlacement.prefix;

var euroSpace = _AutoNumericHelper2.default.cloneObject(euro);
euroSpace.digitGroupSeparator = _AutoNumeric2.default.options.digitGroupSeparator.normalSpace;
var euroSpacePos = _AutoNumericHelper2.default.cloneObject(euroSpace);
euroSpacePos.minimumValue = 0;
var euroSpaceNeg = _AutoNumericHelper2.default.cloneObject(euroSpace);
euroSpaceNeg.maximumValue = 0;
euroSpaceNeg.negativePositiveSignPlacement = _AutoNumeric2.default.options.negativePositiveSignPlacement.prefix;

var percentageEU2dec = _AutoNumericHelper2.default.cloneObject(euro);
percentageEU2dec.currencySymbol = _AutoNumeric2.default.options.currencySymbol.none;
percentageEU2dec.suffixText = '\u202F' + _AutoNumeric2.default.options.suffixText.percentage;
percentageEU2dec.wheelStep = 0.0001; // This targets the `rawValue`, not the formatted one
percentageEU2dec.rawValueDivisor = _AutoNumeric2.default.options.rawValueDivisor.percentage;
var percentageEU2decPos = _AutoNumericHelper2.default.cloneObject(percentageEU2dec);
percentageEU2decPos.minimumValue = 0;
var percentageEU2decNeg = _AutoNumericHelper2.default.cloneObject(percentageEU2dec);
percentageEU2decNeg.maximumValue = 0;
percentageEU2decNeg.negativePositiveSignPlacement = _AutoNumeric2.default.options.negativePositiveSignPlacement.prefix;

var percentageEU3dec = _AutoNumericHelper2.default.cloneObject(percentageEU2dec);
percentageEU3dec.decimalPlaces = 3;
var percentageEU3decPos = _AutoNumericHelper2.default.cloneObject(percentageEU2decPos);
percentageEU3decPos.decimalPlaces = 3;
var percentageEU3decNeg = _AutoNumericHelper2.default.cloneObject(percentageEU2decNeg);
percentageEU3decNeg.decimalPlaces = 3;

var dollarF = _AutoNumericHelper2.default.cloneObject(dollar);
dollarF.formulaMode = _AutoNumeric2.default.options.formulaMode.enabled;
var dollarPos = _AutoNumericHelper2.default.cloneObject(dollar);
dollarPos.minimumValue = 0;
var dollarNeg = _AutoNumericHelper2.default.cloneObject(dollar);
dollarNeg.maximumValue = 0;
dollarNeg.negativePositiveSignPlacement = _AutoNumeric2.default.options.negativePositiveSignPlacement.prefix;
var dollarNegBrackets = _AutoNumericHelper2.default.cloneObject(dollarNeg);
dollarNegBrackets.negativeBracketsTypeOnBlur = _AutoNumeric2.default.options.negativeBracketsTypeOnBlur.parentheses;

var percentageUS2dec = _AutoNumericHelper2.default.cloneObject(dollar);
percentageUS2dec.currencySymbol = _AutoNumeric2.default.options.currencySymbol.none;
percentageUS2dec.suffixText = _AutoNumeric2.default.options.suffixText.percentage;
percentageUS2dec.wheelStep = 0.0001;
percentageUS2dec.rawValueDivisor = _AutoNumeric2.default.options.rawValueDivisor.percentage;
var percentageUS2decPos = _AutoNumericHelper2.default.cloneObject(percentageUS2dec);
percentageUS2decPos.minimumValue = 0;
var percentageUS2decNeg = _AutoNumericHelper2.default.cloneObject(percentageUS2dec);
percentageUS2decNeg.maximumValue = 0;
percentageUS2decNeg.negativePositiveSignPlacement = _AutoNumeric2.default.options.negativePositiveSignPlacement.prefix;

var percentageUS3dec = _AutoNumericHelper2.default.cloneObject(percentageUS2dec);
percentageUS3dec.decimalPlaces = 3;
var percentageUS3decPos = _AutoNumericHelper2.default.cloneObject(percentageUS2decPos);
percentageUS3decPos.decimalPlaces = 3;
var percentageUS3decNeg = _AutoNumericHelper2.default.cloneObject(percentageUS2decNeg);
percentageUS3decNeg.decimalPlaces = 3;

var turkish = _AutoNumericHelper2.default.cloneObject(euro);
turkish.currencySymbol = _AutoNumeric2.default.options.currencySymbol.lira;

/**
 * Predefined options for the most common languages
 */
_AutoNumeric2.default.predefinedOptions = {
    euro: euro,
    euroPos: euroPos,
    euroNeg: euroNeg,
    euroSpace: euroSpace,
    euroSpacePos: euroSpacePos,
    euroSpaceNeg: euroSpaceNeg,
    percentageEU2dec: percentageEU2dec,
    percentageEU2decPos: percentageEU2decPos,
    percentageEU2decNeg: percentageEU2decNeg,
    percentageEU3dec: percentageEU3dec,
    percentageEU3decPos: percentageEU3decPos,
    percentageEU3decNeg: percentageEU3decNeg,
    dollar: dollar,
    dollarPos: dollarPos,
    dollarNeg: dollarNeg,
    dollarNegBrackets: dollarNegBrackets,
    percentageUS2dec: percentageUS2dec,
    percentageUS2decPos: percentageUS2decPos,
    percentageUS2decNeg: percentageUS2decNeg,
    percentageUS3dec: percentageUS3dec,
    percentageUS3decPos: percentageUS3decPos,
    percentageUS3decNeg: percentageUS3decNeg,
    French: euro, // Français
    Spanish: euro, // Español
    NorthAmerican: dollar,
    British: {
        digitGroupSeparator: _AutoNumeric2.default.options.digitGroupSeparator.comma,
        decimalCharacter: _AutoNumeric2.default.options.decimalCharacter.dot,
        currencySymbol: _AutoNumeric2.default.options.currencySymbol.pound,
        currencySymbolPlacement: _AutoNumeric2.default.options.currencySymbolPlacement.prefix,
        negativePositiveSignPlacement: _AutoNumeric2.default.options.negativePositiveSignPlacement.right
    },
    Swiss: { // Suisse
        digitGroupSeparator: _AutoNumeric2.default.options.digitGroupSeparator.apostrophe,
        decimalCharacter: _AutoNumeric2.default.options.decimalCharacter.dot,
        currencySymbol: '\u202FCHF',
        currencySymbolPlacement: _AutoNumeric2.default.options.currencySymbolPlacement.suffix,
        negativePositiveSignPlacement: _AutoNumeric2.default.options.negativePositiveSignPlacement.prefix
    },
    Japanese: japanese, // 日本語
    Chinese: japanese, // 中国語 (Chinese)
    Brazilian: {
        digitGroupSeparator: _AutoNumeric2.default.options.digitGroupSeparator.dot,
        decimalCharacter: _AutoNumeric2.default.options.decimalCharacter.comma,
        currencySymbol: _AutoNumeric2.default.options.currencySymbol.real,
        currencySymbolPlacement: _AutoNumeric2.default.options.currencySymbolPlacement.prefix,
        negativePositiveSignPlacement: _AutoNumeric2.default.options.negativePositiveSignPlacement.right
    },
    Turkish: turkish,
    dotDecimalCharCommaSeparator: {
        digitGroupSeparator: _AutoNumeric2.default.options.digitGroupSeparator.comma,
        decimalCharacter: _AutoNumeric2.default.options.decimalCharacter.dot
    },
    commaDecimalCharDotSeparator: {
        digitGroupSeparator: _AutoNumeric2.default.options.digitGroupSeparator.dot,
        decimalCharacter: _AutoNumeric2.default.options.decimalCharacter.comma,
        decimalCharacterAlternative: _AutoNumeric2.default.options.decimalCharacterAlternative.dot
    },
    integer: {
        decimalPlaces: 0
    },
    integerPos: {
        minimumValue: _AutoNumeric2.default.options.minimumValue.zero,
        decimalPlaces: 0
    },
    integerNeg: {
        maximumValue: _AutoNumeric2.default.options.maximumValue.zero,
        decimalPlaces: 0
    },
    float: {
        allowDecimalPadding: _AutoNumeric2.default.options.allowDecimalPadding.never
    },
    floatPos: {
        allowDecimalPadding: _AutoNumeric2.default.options.allowDecimalPadding.never,
        minimumValue: _AutoNumeric2.default.options.minimumValue.zero,
        maximumValue: _AutoNumeric2.default.options.maximumValue.tenTrillions
    },
    floatNeg: {
        allowDecimalPadding: _AutoNumeric2.default.options.allowDecimalPadding.never,
        minimumValue: _AutoNumeric2.default.options.minimumValue.tenTrillions,
        maximumValue: _AutoNumeric2.default.options.maximumValue.zero
    },
    numeric: {
        digitGroupSeparator: _AutoNumeric2.default.options.digitGroupSeparator.noSeparator,
        decimalCharacter: _AutoNumeric2.default.options.decimalCharacter.dot,
        currencySymbol: _AutoNumeric2.default.options.currencySymbol.none
    },
    numericPos: {
        digitGroupSeparator: _AutoNumeric2.default.options.digitGroupSeparator.noSeparator,
        decimalCharacter: _AutoNumeric2.default.options.decimalCharacter.dot,
        currencySymbol: _AutoNumeric2.default.options.currencySymbol.none,
        minimumValue: _AutoNumeric2.default.options.minimumValue.zero,
        maximumValue: _AutoNumeric2.default.options.maximumValue.tenTrillions
    },
    numericNeg: {
        digitGroupSeparator: _AutoNumeric2.default.options.digitGroupSeparator.noSeparator,
        decimalCharacter: _AutoNumeric2.default.options.decimalCharacter.dot,
        currencySymbol: _AutoNumeric2.default.options.currencySymbol.none,
        minimumValue: _AutoNumeric2.default.options.minimumValue.tenTrillions,
        maximumValue: _AutoNumeric2.default.options.maximumValue.zero
    }
};

Object.getOwnPropertyNames(_AutoNumeric2.default.predefinedOptions).forEach(function (optionName) {
    Object.freeze(_AutoNumeric2.default.predefinedOptions[optionName]);
});
Object.freeze(_AutoNumeric2.default.predefinedOptions);
Object.defineProperty(_AutoNumeric2.default, 'predefinedOptions', { configurable: false, writable: false });